import { render, staticRenderFns } from "./outorderGroupList.vue?vue&type=template&id=9bbf9afe&scoped=true&"
import script from "./outorderGroupList.vue?vue&type=script&lang=js&"
export * from "./outorderGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bbf9afe",
  null
  
)

export default component.exports